module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_intro-heading02-dfe4e518910700336994dfeb43fe51eb.png";